import React from 'react'

import { Box } from '@gousto-internal/citrus-react'
import Helmet from 'react-helmet'

import { RafLandingPage } from '@features/raf-landing-page'

import { useGetCtaProps } from 'routes/Home/Cta'
import { onScrollHandler } from 'routes/Home/Hero/heroUtils'
import { useRecipesFromAllRecipesCollection } from 'routes/Home/useRecipesFromAllRecipesCollection'

import { seo } from './seoConfig'
import { useHandleSignupCTAClick } from './utils'

export const RafPage = () => {
  const handleSignupCTAClick = useHandleSignupCTAClick()
  const recipes = useRecipesFromAllRecipesCollection()
  const { ctaText } = useGetCtaProps()

  return (
    <Box>
      <Helmet title={seo.title} meta={seo.meta} />
      <RafLandingPage
        onScrollHandler={onScrollHandler}
        onSignupCTAClick={handleSignupCTAClick}
        recipes={recipes}
        signupCTA={ctaText}
      />
    </Box>
  )
}
